<template>
  <div
    class="category-intro-main-container"
    :class="accordionClasses"
  >
    <div
      class="category-intro-main"
    >
      <h1 class="category-title">
        {{ heading }}
      </h1>

      <div
        class="category-intro-main-description"
      >
        <div
          v-html="shownDescription"
          class="category-intro-main-description-container"
        />
      </div>
    </div>

    <div
      class="category-intro-main-description-more"
      v-if="isApplicable"
      @click="toggleAccordion"
    >
      <span v-if="!isOpen">Mehr erfahren</span>
      <span v-if="isOpen">Weniger</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryDescriptionAccordion',
  props: {
    heading: {
      type: String,
      required: true,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    toggleAccordion () {
      this.isOpen = !this.isOpen;
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    isApplicable () {
      if (!this.content) {
        return false
      }
      return this.content.indexOf('<!--more-->') > 0
    },
    shownDescription () {
      if (!this.content) {
        return ''
      }
      if (!this.isApplicable || this.isOpen) {
        return this.content.replace('<!--more-->', '')
      }
      return this.content.split('<!--more-->')[0]
    },
    accordionClasses () {
      return {
        'is-closed': !this.isOpen
      };
    }
  }
}
</script>
